import { makeStyles, shorthands } from '@fluentui/react-components';
import { Color } from 'libs/theme/src/lib/colors';

export const CustomStyles = makeStyles({
  delegateContainer: { display: 'flex', ...shorthands.gap('8px') },

  icon: { color: Color.blue_700 },
});
